<template>
  <div class="v_info_x my-wrapper">
    <div class="v_info">
      <div v-if="operate === 'detail' && status !== 4" class="detail-qrcode">
        <div class="qrimg-x">
          <div id="qrImg" class="qrImg">
            <!-- <canvas id="canvas"></canvas> -->
          </div>
        </div>
        <div class="success-code">预约码：{{ appointmentCode }}</div>
        <div class="success-tip">
          该访客的预约码如上，请截图或长按保存告知该访客，方便其登记进入，或访客可通过手机号查询自己的预约码
        </div>
        <div class="bottom-tip">
          <hua-notice-bar
              :scrollable="false"
              text="长按或截图保存，避免丢失"
              left-icon="info-o"
              background="#fff4e6"
              color="#ff7514"
          >
            <template slot="left-icon">
              <hua-icon
                  name="info"
                  color="#ff6a00"
                  size="16px"
                  class="slot-icon"
              ></hua-icon>
            </template
            >
          </hua-notice-bar>
        </div>
      </div>
      <hua-form @submit="utils.debounce(onSubmit, 1000)" :label-width="120" :input-align="'right'">


        <!-- 来访信息 -->
        <div class="info_title icon-title">
            <img src="@/image/jzgyy_pic_msg2.png" alt="">
            {{ tabsList[1].label }}
        </div>
        <div class="form-block">
        <!-- 来访时间 field4-->
        <hua-field
            key="field4"
            name="picker"
            readonly
            clickable
            required
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field4'].label"
            :rules="formFields['field4'].rules"
            :value="formFields['field4'].value ? formFields['field4'].value : onConfirmArriveTime (formFields['field4'].currentDate)"
            :placeholder="formFields['field4'].placeholder"
            @click="!!id ? '' : arriveClick()"
        />
        <hua-popup v-model="formFields['field4'].showPicker" round position="bottom">
          <!-- type="date" -->
          <hua-datetime-picker
              key="field8"
              type="datetime"
              title="来访时间"
              :min-date="formFields['field4'].minDate"
              :max-date="formFields['field4'].maxDate"
              v-model="formFields['field4'].currentDate"
              @confirm="onConfirmArriveTime"
              @cancel="formFields['field4'].showPicker = false"
          />
        </hua-popup>
        <hua-field
            name="picker"
            readonly
            clickable
            required
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field5'].label"
            :rules="formFields['field5'].rules"
            :value="formFields['field5'].value ? formFields['field5'].value : onConfirmleaveTime (new Date(new Date(new Date().toLocaleDateString()).getTime() + (22 * 60 * 60 * 1000)))"
            :placeholder="formFields['field5'].placeholder"
            @click="!!id ? '' : leaveClick()"
        />
        <hua-popup v-model="formFields['field5'].showPicker" round position="bottom">
          <hua-datetime-picker
              type="datetime"
              title="离访时间"
              :min-date="formFields['field5'].minDate"
              :max-date="formFields['field5'].maxDate"
              v-model="formFields['field5'].currentDate"
              @confirm="onConfirmleaveTime"
              @cancel="formFields['field5'].showPicker = false"
          />
        </hua-popup>
        <!-- 访客区域 field18-->
        <hua-field
            key="field25"
            v-if="v_personid || id"
            :right-icon="isNoBtn ? '' : 'arrow'"
            readonly
            :type="formFields['field18'].type"
            :label="formFields['field18'].label"
            :required="formFields['field18'].require"
            :rules="formFields['field18'].rules"
            v-model="formFields['field18'].value"
            :placeholder="formFields['field18'].placeholder"
            @click="formFields['field18'].showPicker = true"
        />
        <hua-popup v-model="formFields['field18'].showPicker" position="bottom" round @close="closeAreaPopup">
          <div class="customContent">
            <div class="area-content-title">
              <div @click="closeAreaPopup">取消</div>
              <div>访问区域</div>
              <div @click="areaChange">确定</div>
            </div>
            <hua-checkbox-group v-model="areaIdListTemp">
              <hua-cell-group>
                <hua-cell
                    clickable
                    v-for="item in formFields['field18'].areaList"
                    :key="item.value"
                    :title="item.text"
                >
                  <template #right-icon>
                    <hua-checkbox ref="checkboxes" :name="item.value"/>
                  </template>
                </hua-cell>
              </hua-cell-group>
            </hua-checkbox-group>
          </div>
        </hua-popup>
        </div>

        <div class="info_title icon-title">
            <img src="@/image/jzgyy_pic_msg3.png" alt="">
            {{ tabsList[2].label }}
        </div>
        <div class="form-block">
        <!-- 来访人数field9 -->
        <hua-field
            key="field15"
            clearable
            :readonly="visitorMode == 1 || !!id"
            :type="formFields['field9'].type"
            :label="formFields['field9'].label"
            :required="formFields['field9'].require"
            :rules="formFields['field9'].rules"
            v-model="formFields['field9'].value"
            :placeholder="formFields['field9'].placeholder"
        />
        <!-- 联系电话field12 -->
        <hua-field
            clearable
            key="field19"
            :maxLength="formFields['field12'].maxLength"
            :readonly="!!id"
            :type="formFields['field12'].type"
            :label="formFields['field12'].label"
            :required="formFields['field12'].require"
            :rules="formFields['field12'].rules"
            v-model="formFields['field12'].value"
            :placeholder="formFields['field12'].placeholder"
        />
        </div>

        <!-- 邀约  存在登录人员的v_personid,不存在数据id-->
        <div v-if="v_personid && !id" style="margin: 16px">
          <hua-button
              round
              block
              type="primary"
              native-type="submit"
              :disabled="isDisabled"
          >提交
          </hua-button
          >
        </div>
        <!-- 待审核  存在数据id且登录的用户是可以审核的-->
        <div v-else-if="id && operate === 'audit' && reviewable" class="btn-box">
          <hua-button class="pass-fail" round type="default" @click.prevent="notAllow"
          >不通过
          </hua-button
          >
          <hua-button class="submit" round type="primary" @click.prevent="utils.debounce(allow, 1000)"
          >通过
          </hua-button
          >
        </div>
        <!-- 预约成功等  相当于只能查看预约成功的、失败的、已离访的，审核不通过的、登录的用户不能审核的-->
        <div v-else-if="isNoBtn"></div>
        <!-- 预约 -->
        <div v-else :class="isEpidemicInfoRequired ? 'btn-box' : 'btn-box-no'">
          <hua-button
              v-if="isEpidemicInfoRequired"
              class="prevstep"
              round
              type="default"
              style="bordercolor: #0a86ff"
              @click.prevent="changeSteps"
          >上一步
          </hua-button
          >
          <hua-button
              :class="isEpidemicInfoRequired ? 'submit' : ''"
              round
              type="primary"
              native-type="submit"
          >提交
          </hua-button
          >
        </div>
      </hua-form>
    </div>
  </div>
</template>
<script>
import api from '@/constants/api'
import utils from '@/constants/utils'
import eventBus from '@/constants/eventBus.js'
import rexp from '@/constants/rexp'
import moment from 'moment'
import {aes_decrypt, getKey} from '@/tools/myEncrypt'
export default {
  name: 'reserve',
  components: {},
  props: {
    // 访问模式1学生2教职工，学生一定有，老师为空
    visitorMode: {
      type: [String, Number],
      default: ''
    },
    // 查看详情时有 isv_id,id,operate,v_timeStr,v_healthCodePic,v_personid
    // 邀约有v_personid,u_phone,u_name
    v_personid: {
      type: String,
    },
    isv_id: {
      type: String,
    },
    id: {
      type: String | Number,
    },
    operate: {
      type: String,
    },
    v_timeStr: {
      type: String,
    },
    v_healthCodePic: {
      type: String,
    },
    steps: {
      type: Number,
    },
    u_name: {
      type: String,
    },
    u_phone: {
      type: String,
    },
    isOrder: {
      type: Boolean,
      default: true
    },
    openId: {
      type: String,
      default: null
    }
  },
  created() {
    this.picArr = []
    eventBus.$on('add', (message) => {
      this.picArr = message
      //一些操作，message就是从兄弟组件传过来的值
    })
    // this.isv_id = this.isvId
    // this.getVisitorType()
    this.getBaseConfig()
    this.getVistorArea()
  },

  mounted() {
    this.$nextTick(() => {
      if(this.visitorMode == 1) {
        this.formFields['field9'].value = 1;
      }
      if (this.v_personid && !this.id) {
        // this.formFields['field1'].value = this.u_phone || localStorage.getItem('u_phone')
        // this.formFields['field2'].text =
        //     this.u_name || JSON.parse(sessionStorage.getItem('u_name'))
      } else if (this.id) {
        this.getVisitorInfoById()
      }
    })
  },

  data() {
    return {
      utils,
      isNoBtn: false,
      isDisabled: false,
      reviewable: null,
      images: [],
      isEpidemicInfoRequired: false,
      show: false,
      picArr: [],
      isvId: null,
      isIntervieweeRequired: true,
      isFollowerRequired: true,
      visitorArea: '',
      //rexp setting
      rexp,
      areaIdListTemp: [], // 所选访问区域
      //btndisabled
      searchDisabled: true,
      //图片上传
      fileList: [],
      //访问次数限制
      visitNum: 10000,
      visitorNum: 10000,
      //tabs
      showPopover: false,
      actions: [{text: '临时访问不支持跨天；长期访问支持跨天，不限制天数'}],
      tabActive: '1',
      tabsList: [
        {
          label: '被访人员信息',
          value: '1',
        },
        {
          label: '来访信息',
          value: '2',
        },
        {
          label: '访客信息',
          value: '3',
        },
      ],
      show: false,
      indexList: [1, 2, 3],
      //主访人信息
      formFields: {
        field4: {
          paramName: 'v_timeStr',
          value: '',
          label: '来访时间',
          placeholder: '请选择',
          require: true,
          readonly: true,
          showPicker: false,
          //new Date(2020, 0, 1),
          minDate: new Date(),
          //new Date(2030, 12, 31),
          maxDate: new Date((new Date() / 1000 + 86400 * 3650) * 1000),
          currentDate: new Date(new Date().getTime() + (5 * 60 * 1000) - 1),
          rules: [
            {
              required: true,
              message: '请选择来访时间',
            },
          ],
        },
        field5: {
          paramName: 'v_lvTimeStr',
          value: '',
          label: '离访时间',
          placeholder: '请选择',
          require: true,
          readonly: true,
          showPicker: false,
          minDate: new Date(), //new Date(2020, 0, 1),
          maxDate: new Date((new Date() / 1000 + 86400 * 3650) * 1000), //new Date(2030, 12, 31),
          currentDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + (22 * 60 * 60 * 1000)),
          rules: [
            {
              required: true,
              message: '请选择离访时间',
            },
          ],
        },
        field9: {
          paramName: 'v_personSum',
          type: 'digit',
          value: '',
          label: '来访人数',
          placeholder: '请输入1-20正整数',
          require: true,
          rules: [
            {
              pattern: /^([1-9]|1\d{1}|20)$/,
              message: (value) => {
                if (value) {
                  return '来访人数支持1-20的正整数'
                } else {
                  return '请输入来访人数'
                }
              },
            },
          ],
        },
        field12: {
          paramName: 'v_phone',
          type: 'tel',
          value: '',
          label: '访客电话',
          maxLength: 11,
          placeholder: '请输入',
          require: true,
          rules: [
            {
              pattern: rexp.phone,
              message: (value) => {
                if (value) {
                  return '手机号码格式不正确'
                } else {
                  return '请输入手机号码'
                }
              },
            },
          ],
        },
        field18: {
          paramName: 'areaIdList',
          type: 'text',
          value: '',
          label: '访问区域',
          placeholder: '请选择',
          require: true,
          showPicker: false,
          areaNameList: [],
          areaList: [],
          areaIdList: [],
          rules: [
            {
              validator: this.areaVlidator,
              message: '请选择访问区域',
            },
          ],
        },
      },
      followFormList: [],
      appointmentCode: '',
      qrcode: null,
      v_barCode: '',
      status: '',
      index: 0,
      appointTime: '',
      obj: null,
      visitorTypeList: [],
    }
  },
  watch: {
    visitorMode: {
      handler() {
        if(this.visitorMode == 1) {
          this.formFields['field9'].value = 1;
        }
      }
    }
  },
  methods: {
    changeSteps() {
      this.$emit('stepsChange', 0)
    },

    // 用户信息回显父组件切换tab至邀约页面时调用
    echoUser() {
      this.formFields['field1'].value = this.u_phone || localStorage.getItem('u_phone')
      this.formFields['field2'].text =
          this.u_name || sessionStorage.getItem('u_name')
    },

    // 获取基础配置信息
    getBaseConfig() {
      api.getBaseConfig().then((res) => {
        this.isIntervieweeRequired =
            res.data['visitor.interviewee.required'] === '0' ? false : true
        this.isFollowerRequired =
            res.data['followed.visitor.required'] === '0' ? false : true
        this.isEpidemicInfoRequired = !!res.data['visitor.epidemic.enable']
      })
    },

    // 访客类型
    getVisitorType() {
      this.visitorTypeList = []
      let that = this
      api.getVisitorType()
      .then((res) => {
        console.log(res, '78798');
        that.visitorTypeList = res.data.map((item, i) => {
          return {text: item.typeName, value: item.id, id: 'field6', index: i}
        })
        that.formFields['field6'].columns = that.visitorTypeList
      })
      .catch((err) => {
        console.log(err)
      })
    },

    // 访客区域
    getVistorArea() {
      let param = {
        pageNum: 1,
        pageSize: 1000,
        areaName: '',
        visitorMode: this.visitorMode ? this.visitorMode : ''
      }
      api.getVistorArea(param).then((res) => {
        let data = res.data.pageData
        console.log('dataaaaa', data);
        data.map((item) => {
          this.formFields['field18'].areaList.push({
            text: item.areaName,
            value: item.id,
          })
        })
      })
    },


    // 获取图片
    getImageUrl(url) {
      if (url) {
        if (url.split('http').length > 1) {
          var urlArray = url.split('/')
          urlArray.shift()
          urlArray.shift()
          urlArray.shift()

          return (
              location.origin +
              '/evo-apigw/evo-oss/' +
              urlArray.join('/') +
              '?token=' +
              localStorage.getItem('accessToken')
          )
        } else {
          return location.origin + '/evo-apigw/evo-oss/' + url
        }
      }
    },

    // 创建二维码
    getPersonQRCode(data) {
      api.getVisitConfig(150).then(resp => {
        if (resp.data[0].value  === 'true') {
          let qrcode
            qrcode = new QRCode(document.getElementById('qrImg'), {
              width: 120,
              height: 120,
            })
            qrcode.makeCode(data)
            let img = document.getElementById('qrImg').getElementsByTagName('img')[0]
            let canvas = document.getElementById('qrImg').getElementsByTagName('canvas')[0]
            if (canvas) {
              img.src = canvas.toDataURL('image/png')
              img.style.display = 'block'
              canvas.style.display = 'none'
          }
        }
      })
    },

    // 选择访问区域
    areaChange() {
      this.formFields['field18'].areaIdList = this.areaIdListTemp;
      let areaNameList = []
      this.formFields['field18'].areaList.map((item) => {
        if (this.formFields['field18'].areaIdList.includes(item.value)) {
          areaNameList.push(item.text)
        }
      })
      this.formFields['field18'].value = areaNameList.join(',')
      this.formFields['field18'].showPicker = false
    },
    // 关闭访问区域弹弹出层
    closeAreaPopup() {
      this.areaIdListTemp = this.formFields['field18'].areaIdList;
      this.formFields['field18'].showPicker = false;
    },
    onConfirmleaveTime(obj) {
      this.formFields['field5'].value = moment(this.timeToString(obj)).format('YYYY/MM/DD HH:mm')
      this.formFields['field5'].showPicker = false
      let time1 = this.formFields['field4'].currentDate
          ? this.formFields['field4'].currentDate.toDateString()
          : 0
      let time2 = this.formFields['field5'].currentDate
          ? this.formFields['field5'].currentDate.toDateString()
          : 0
      if (time1 != time2) {
        this.$toast('预约时间跨度超过1天')
      }
    },
    leaveClick() {
      if (this.formFields['field4'].value.length === 0) {
        this.$toast('请选择来访时间！')
      } else {
        this.$nextTick(() => {
          this.formFields['field5'].showPicker = true
        })
      }
    },
    //时间格式
    formatter(type, value) {
      if (type === 'year') {
        return value + '年' //this.t('year')
      }
      if (type === 'month') {
        return value + '月' //this.t('month')
      }
      if (type === 'day') {
        return value + '日' //this.t('day')
      }
      if (type === 'hour') {
        return value + '时' //this.t('hour')
      }
      if (type === 'minute') {
        return value + '分' // this.t('minute')
      }
      if (type === 'second') {
        return value + '秒' //this.t('second')
      }
      return value
    },

    // 被访人员手机格式校验
    isv_phoneValidate(value) {
      if (this.isIntervieweeRequired) {
        if (!value) {
          return false
        } else {
          if (!rexp.phone.test(value)) {
            return false
          } else {
            return true
          }
        }
      } else {
        if (value) {
          if (!rexp.phone.test(value)) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },

    //phoneNum
    validatorPhoneNum(val) {
      let myreg = /^1[0-9]{10}$}$/
      if (myreg.test(val)) {
        this.show = true
        return true
      } else {
        this.show = false
        return false
      }
    },

    phoneNumChange(value) {
      let phoneNum = value //e.target.value //this.formFields['field1'].value
      let reg = /^[0-9]{11}$/
      if (reg.test(phoneNum)) {
        this.searchDisabled = false
      } else {
        this.searchDisabled = true
      }
      if (!value) {
        this.formFields['field2'].text = ''
        this.formFields['field2'].value = ''
      }
    },

    async phoneNumSearch() {
      if (this.searchDisabled) {
        return
      } else {
        let phone = this.formFields['field1'].value
        // 先获取密钥
        const keyInfo = await getKey()
        if (!keyInfo) {
          this.$toast('获取密钥失败，请重试')
          return
        }
        // 再获取业务数据（传入时间戳）
        api.getIntervieweeNameByPhone(phone, keyInfo.visitorstampKey)
        .then(async (res) => {
          // 最后解密
          const decryptData = await aes_decrypt(res.data, keyInfo)
          if (!decryptData) {
            this.$toast('解密失败，请重试')
            return
          }
          res.data = decryptData
          this.formFields['field2'].text = res.data.name
          this.formFields['field2'].value = res.data.id
          this.isvId = res.data.id
        })
        .catch((err) => {
          this.$toast(err.errMsg)
        })
      }
    },

    //timeToString
    timeToString(timeObj) {
      var str = ''
      var year = timeObj.getFullYear()
      var month = timeObj.getMonth() + 1
      var date = timeObj.getDate()
      var time = timeObj.toTimeString().split(' ')[0].split(':').slice(0, 2).join(':')
      var rex = new RegExp(/:/g)
      str = year + '/' + month + '/' + date + ' ' + time
      return str
    },

    areaVlidator(value) {
      if (value) {
        return true
      } else {
        return false
      }
    },


    arriveClick() {
      this.formFields['field4'].showPicker = true
    },

    onConfirmArriveTime(obj) {
      this.obj = obj
      this.formFields['field4'].value = moment(this.timeToString(obj)).format('YYYY/MM/DD HH:mm')
      this.formFields['field4'].showPicker = false
    },

    //fieldlist 转 整体obj
    field2Obj(obj) {
      let targetObj = {}
      for (let i in obj) {
        if (typeof obj[i].paramName !== 'undefined' && (obj[i].value + '').length) {
          if (['chargeOrNot'].includes(obj[i].paramName)) {
            targetObj[obj[i].paramName] = obj[i].value
          } else {
            targetObj[obj[i].paramName] = obj[i].value + ''
          }
        }
      }
      return targetObj
    },

    // 表单提交
    onSubmit(values) {
      this.isDisabled = true
      let paramData = this.field2Obj(this.formFields)
      paramData.isv_id = this.v_personid ? this.v_personid : this.isvId
      paramData.areaIdList = [...this.formFields['field18'].areaIdList]
      //填充到秒
      paramData.v_timeStr = moment(paramData.v_timeStr + ':00').format('YYYY-MM-DD HH:mm:ss')
      paramData.v_lvTimeStr = moment(paramData.v_lvTimeStr + ':00').format('YYYY-MM-DD HH:mm:ss')
      paramData.visitorMode = this.visitorMode ? this.visitorMode :  2;

      api.addVisitor(paramData)
      .then((res) => {
        if (res.success) {
          this.isDisabled = false
          this.$toast('邀约成功')
        }
      })
      .catch((err) => {
        this.isDisabled = false
        this.$toast(err.errMsg)
      })
    },

    // 审批不通过
    notAllow() {
      let params = {
        id: this.id,
        visitorType: 2,
        result: false,
        appointTime: this.appointTime,
        isv_id: Number(this.isv_id) || Number(this.isv_id) === 0 ? Number(this.isv_id) : ''
      }
      api.review(params)
      .then((res) => {
        this.$toast('操作成功')
        this.$router.go(-1)
      })
      .catch((err) => {
        this.$toast(err.errMsg)
      })
    },

    // 防疫开关未开启审批通过
    allow() {
      let areaIdList = [...this.formFields['field18'].areaIdList]
      if (!areaIdList.length) {
        return this.$toast('请选择访问区域')
      }
      if (this.isEpidemicInfoRequired && this.v_healthCodePic) {
        this.show = true
      } else {
        let params = {
          id: this.id,
          visitorType: 2,
          result: true,
          appointTime: this.appointTime,
          areaIdList,
          times: this.formFields['field7'].value,
          secondVisitorType: this.formFields['field6'].value,
          isv_id: Number(this.isv_id) || Number(this.isv_id) === 0 ? Number(this.isv_id) : ''
        }
        api.review(params)
        .then((res) => {
          this.$toast('操作成功')
          this.$router.go(-1)
        })
        .catch((err) => {
          this.$toast(err.errMsg)
        })
      }
    },

    // 防疫开关开启确认审核通过，关闭详情弹框、返回列表页面
    onReviewConfirm() {
      let areaIdList = [...this.formFields['field18'].areaIdList]
      let params = {
        id: this.id,
        visitorType: 2,
        result: true,
        areaIdList,
      }
      api.review(params)
      .then((res) => {
        this.$toast('操作成功')
        this.$router.go(-1)
      })
      .catch((err) => {
        this.$toast(err.errMsg)
      })
    },

    // 取消审核关闭防疫详情弹框
    onReviewCancel() {
      console.log('取消')
    },
  },
}
</script>
<style lang="less">
.v_info_x {
  width: 100%;
  height: 100%;
  .v_info {
    .info_title {
      color: #007aff;
      padding-left: 0.17rem;
      font-size: 0.14rem;
      line-height: 0.33rem;
    }
    .icon-title {
        display: flex;
        align-items: center;
        img {
            margin-top: -2px;
            margin-right: 5px;
            width: 15px;
        }
    }

    .info_tip {
      color: #f00;
      padding-left: 0.12rem;
      font-size: 0.1rem;
      line-height: 0.3rem;
    }

    .disableSearch {
      color: #c8c9cc;
    }

    .activeSearch {
      color: #1989fa;
    }

    .followSpace {
      width: 100%;
      height: 0.2rem;
      background-color: #f6f6f6;
    }
  }

  .detail-qrcode {
    text-align: center;
    padding: 30px 20px 10px;
    background-color: #fff;

    .success-code {
      color: #181818;
      font-size: 18px;
      margin-top: 15px;
    }

    .success-tip {
      margin: 20px 40px;
      color: #8c8c8c;
    }

    .qrImg {
      img {
        margin: auto;
      }
    }

    .bottom-tip {
      margin: 20px 60px 30px;
    }
  }

  .visitType {
    .hua-popover__content {
      width: 2.3rem;
      height: 0.4rem;

      .hua-popover__action {
        height: 0.4rem;
        font-size: 0.12rem;
        line-height: 0.22rem;
      }
    }
  }

  .hua-cell {
    align-items: center;
  }

  .customContent {
    height: 350px;
    overflow-y: auto;

    .area-content-title {
      padding: 10px 15px;
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > :nth-child(1) {
        color: #8c8c8c;
      }

      > :nth-child(2) {
        font-size: 16px;
      }

      > :nth-child(3) {
        color: #1989fa;
      }
    }
  }

  .btn-box {
    margin: 10px 0;
    padding: 15px;
    background-color: #fff;
    display: flex;
  }

  .btn-box-no {
    margin: 16px;

    .hua-button {
      width: 100%;
    }
  }

  .prevstep {
    width: 30%;
    border-color: #1989fa;
  }

  .pass-fail {
    width: 30%;
    border-color: #f00;

    .hua-button__text {
      color: red;
    }
  }

  .submit {
    flex: 1;
    margin-left: 15px;
  }

  .hua-image-preview {
    top: 55px;
    height: 350px;
  }
  .hua-uploader__mask {
    background-color: transparent !important;
  }
}
</style>
<style lang="less" scoped>
    .my-wrapper {
        height: calc(100vh - 60px);
        overflow: auto;
        background-color: #f4f5f6;
        .form-block {
          border-radius: 10px;
          margin: 0 10px;
          overflow: hidden;
        }
    }
</style>
